import React, { Component } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

/* containers */
import LoginPage from './containers/LoginPage';
import LogoutPage from './containers/LogoutPage';
import CallbackCasPage from './containers/CallbackCasPage';
import AuthHelper from './helpers/auth';
import UnauthorizedPage from './containers/UnauthorizedPage';

import ApplicationListPage from './containers/ApplicationListPage';

import ApplicationBasicPage from './containers/ApplicationDetailPage/ApplicationBasicPage';
import ApplicationDetailPage from './containers/ApplicationDetailPage/';

import FavoriteDestinationListPage from './containers/FavoriteDestinationListPage';

/* layouts */
import BasicLayout from './layouts/basic-layout';
import NavigationLayout from './layouts/navigation-layout';

//
const routes = [
	// General and Authentication
	{ path: '/unauthorized', exact: true, isPrivate: false, Layout: BasicLayout, layoutClass: 'narrow', Component: UnauthorizedPage },
	{ path: '/callback/cas', exact: true, isPrivate: false, Layout: BasicLayout, layoutClass: 'narrow', Component: CallbackCasPage },
	{ path: '/login', exact: true, isPrivate: false, Layout: BasicLayout, Component: LoginPage },
	{ path: '/logout', exact: true, isPrivate: false, Layout: BasicLayout, Component: LogoutPage },

	//	applications
	{ path: '/applications', exact: true, isPrivate: true, Layout: NavigationLayout, Component: ApplicationListPage },
	{ path: '/applications/create', exact: true, isPrivate: true, Layout: NavigationLayout, Component: ApplicationBasicPage },
	{ path: '/applications/id/basic', exact: true, isPrivate: true, Layout: NavigationLayout, Component: ApplicationDetailPage },

	//	favorite-destination
	{ path: '/favorite-destination', exact: true, isPrivate: true, Layout: NavigationLayout, Component: FavoriteDestinationListPage }
];

function getRedirectedPath(location) {
	if (location.pathname.split('?')[0] === '/login' && location.pathname.split('?').length > 1) {
		return location.pathname + location.search + location.hash;
	}

	// skip the redirection from these routes
	if (['/login', '/callback/cas', '/logout'].indexOf(location.pathname.split('?')[0]) !== -1) {
		return '/login';
	}
	return `/login?path=${location.pathname + location.search + location.hash}`;
}

const PrivateRoute = ({ layout: Layout, component: Component, ...rest }) => (
	<Route
		{...rest}
		render={props => {
			if (AuthHelper.isAuthenticated()) {
				return (
					<Layout>
						<Component {...props} />
					</Layout>
				);
			} else {
				return (
					<Redirect
						to={{
							pathname: getRedirectedPath(props.location),
							state: { from: props.location }
						}}
					/>
				);
			}
		}}
	/>
);

export class Routes extends Component {
	render() {
		const { location } = this.props;
		return (
			<Switch location={location}>
				{routes.map(({ path, exact, isPrivate, Layout, Component }) => {
					if (isPrivate) {
						return <PrivateRoute key={0} path={path} exact={exact} layout={Layout} component={Component} />;
					} else {
						return (
							<Route
								key={0}
								path={path}
								exact={exact}
								render={props => (
									<Layout location={location}>
										<Component {...props} />
									</Layout>
								)}
							/>
						);
					}
				})}
				<Route render={props => (AuthHelper.isAuthenticated() ? <Redirect to={'/applications'} /> : <Redirect to={getRedirectedPath(props.location)} />)} />
			</Switch>
		);
	}
}

export default withRouter(Routes);
